// Saves a fetched blob (e.g. a CSV report) to disk by clicking a transient
// object-URL anchor, then releases the URL. Shared across features that fetch
// a file as a blob (authenticated downloads can't be a plain <a href>, since
// the request needs the auth header the axios client attaches).
export const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename || 'download';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

// Reads the download filename a server set on a blob response's
// Content-Disposition header, falling back to a caller-supplied name when the
// header is absent.
export const filenameFromContentDisposition = (headers, fallback) => {
  const disposition = headers?.['content-disposition'] || '';
  const match = /filename="?([^";]+)"?/.exec(disposition);
  return match ? match[1] : fallback;
};
